// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"461":"cf33e1f4","812":"4575c0fd","872":"504c0dd5","908":"47e2f837"}[chunkId] + ".chunk.css";
};